// Figma: login-link-expired (node 18050:634) / login-link-already-used (node 18050:665).
// Terminal states for TokenVerification when the magic-link token can't be redeemed —
// LC2's old TokenVerification just silently navigate('/login') on any failure; this shows
// the reason when we can classify it (see authErrorHelpers.classifyTokenError).
import React from 'react';
import PropTypes from 'prop-types';
import StatusCard from './components/StatusCard';
import linkExpiredIcon from '../../assets/auth/link-expired-icon.svg';
import linkUsedIcon from '../../assets/auth/link-used-icon.svg';
import {tokens} from '../../themes/ThemeCustomization';

const VARIANTS = {
    expired: {
        icon: linkExpiredIcon,
        iconBackground: tokens.color.error50,
        title: 'Link expired',
        description: 'This login link has expired. Links are valid for 15 minutes after being sent.'
    },
    'already-used': {
        icon: linkUsedIcon,
        iconBackground: tokens.color.info50,
        title: 'Link already used',
        description: 'This login link has expired. Links are valid for 15 minutes after being sent.'
    }
};

const LinkStatusCard = ({variant, onRequestNewLink, onBackToLogin}) => {
    const config = VARIANTS[variant];
    return (
        <StatusCard
            icon={config.icon}
            iconBackground={config.iconBackground}
            title={config.title}
            description={config.description}
            primaryAction={{label: 'Request a new link', onClick: onRequestNewLink}}
            secondaryAction={{label: 'Back to login', onClick: onBackToLogin}}
        />
    );
};

LinkStatusCard.propTypes = {
    variant: PropTypes.oneOf(['expired', 'already-used']).isRequired,
    onRequestNewLink: PropTypes.func.isRequired,
    onBackToLogin: PropTypes.func.isRequired
};

export default LinkStatusCard;
